import type { Prompt } from "@1js/pl-card-components";
import { type Status } from "@1js/pl-types";
import { useReducer } from "react";
import type { WebPrompt } from "../../components/data";

export type State = {
  prompt: WebPrompt;
  init?: boolean;
  status: Status;
  threeSFailed?: boolean;
};

type Action =
  | {
      type: "BOOKMARK_INIT";
    }
  | {
      type: "BOOKMARK_SUCCEED";
      payload: { value: boolean };
    }
  | {
      type: "BOOKMARK_FAILED";
    }
  | {
      type: "REQUEST_BOOKMARKED_PROMPTS_INIT";
    }
  | {
      type: "REQUEST_BOOKMARKED_PROMPTS_SUCCEED";
      payload: { prompts: Prompt[] };
    }
  | {
      type: "REQUEST_BOOKMARKED_PROMPTS_FAILED";
    };

const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case "REQUEST_BOOKMARKED_PROMPTS_INIT":
      return {
        ...state,
        status: "loading",
      };
    case "REQUEST_BOOKMARKED_PROMPTS_SUCCEED": {
      const matched = action.payload.prompts.find(
        (x) => x.PromptId === state.prompt.PromptId
      );
      return {
        ...state,
        status: "idle",
        init: true,
        prompt: {
          ...state.prompt,
          UserActivity: matched
            ? matched.UserActivity
            : { ...state.prompt.UserActivity },
        },
      };
    }
    case "REQUEST_BOOKMARKED_PROMPTS_FAILED":
      return {
        ...state,
        status: "idle",
        init: true,
        threeSFailed: true,
      };
    case "BOOKMARK_INIT":
      return {
        ...state,
        prompt: { ...state.prompt, IsBookmarking: true },
      };
    case "BOOKMARK_SUCCEED":
      return {
        ...state,
        prompt: {
          ...state.prompt,
          IsBookmarking: false,
          UserActivity: {
            ...state.prompt.UserActivity,
            Favorite: {
              ...state.prompt.UserActivity.Favorite,
              IsFavorite: action.payload.value,
            },
          },
        },
      };
    case "BOOKMARK_FAILED":
      return {
        ...state,
        prompt: { ...state.prompt, IsBookmarking: false },
      };
    default:
      return state;
  }
};

function useDetailPrompt(prompt: WebPrompt) {
  const [state, dispatch] = useReducer(reducer, {
    prompt: prompt,
    init: false,
    status: "idle",
  });

  return {
    state,
    dispatch,
  };
}

export default useDetailPrompt;
